// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"34fe04f1","667":"da08bb47","977":"18a22cef"}[chunkId] + ".chunk.js";
};